module.exports = __webpack_public_path__ + "img/cloud.820830de.svg";